import { Link } from "react-router-dom";
import FanchaLogo from "./FanchaLogo";
import { SITE_NAME, tagCloud } from "@/mocks/fancha";

const COLUMNS = [
  {
    title: "栏目导航",
    links: [
      { label: "反转档案", to: "/#cases" },
      { label: "人设反转", to: "/?cat=persona" },
      { label: "身份揭秘", to: "/?cat=identity" },
      { label: "滤镜打假", to: "/?cat=glamour" },
    ],
  },
  {
    title: "热度榜单",
    links: [
      { label: "本周热度榜", to: "/#rank" },
      { label: "吃瓜方法论", to: "/#method" },
      { label: "常见问题", to: "/#faq" },
      { label: "最新深扒", to: "/#latest" },
    ],
  },
  {
    title: "关于我们",
    links: [
      { label: "关于反差吃瓜局", to: "/about" },
      { label: "内容原则", to: "/about#principle" },
      { label: "投稿与联系", to: "/about#contact" },
    ],
  },
];

export default function FanchaFooter() {
  return (
    <footer className="mt-20 bg-foreground-900 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="[&_span]:!text-background-100">
              <FanchaLogo />
            </div>
            <p className="mt-4 max-w-xs text-sm leading-6 text-background-200/80">
              专注拆解「人设反转、身份揭秘、前后对比」的内容媒体。冷静吃瓜，讲逻辑、讲证据，拒绝断章取义与网络暴力。
            </p>
            <p className="mt-4 text-sm text-background-200/70">
              商务合作与线索投递：
              <a
                href="mailto:contact@fancha.example"
                rel="nofollow"
                className="ml-1 text-accent-300 underline decoration-accent-400/50 underline-offset-4 hover:text-accent-200"
              >
                contact@fancha.example
              </a>
            </p>
          </div>

          {COLUMNS.map((col) => (
            <div key={col.title}>
              <h3 className="font-heading text-sm font-bold tracking-wide text-background-50">{col.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      className="inline-block whitespace-nowrap text-sm text-background-200/80 transition-colors hover:text-accent-300"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* 话题标签云 */}
        <div className="mt-10 border-t border-background-100/15 pt-8">
          <p className="text-xs font-medium tracking-widest text-background-200/70">热门话题</p>
          <div className="mt-3 flex flex-wrap gap-2">
            {tagCloud.map((tag) => (
              <Link
                key={tag}
                to={`/?q=${encodeURIComponent(tag)}`}
                className="whitespace-nowrap rounded-full border border-background-100/20 px-3 py-1 text-xs text-background-200/70 transition-colors hover:border-accent-400 hover:text-accent-300"
              >
                #{tag}
              </Link>
            ))}
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-100/15 pt-6 text-xs text-background-200/60 sm:flex-row">
          <p>
            © {new Date().getFullYear()} {SITE_NAME} · 本网站当事人及事件均为虚构演示内容，仅供内容传播与观察研究。
          </p>
          <p className="flex items-center gap-2">
            <span className="inline-flex items-center gap-1">
              <i className="ri-flashlight-line" /> 冷静吃瓜 · 理性围观
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
}